export default __webpack_public_path__ + "static/media/chevron-r.a54a9c50.svg";